export default "__VITE_ASSET__8512f9c8__";